import { Component } from '@angular/core';

@Component({
  selector: 'app-fifth-section-landing',
  templateUrl: './fifth-section-landing.component.html',
  styleUrls: ['./fifth-section-landing.component.scss']
})
export class FifthSectionLandingComponent {

  constructor() { }
}
